const MASK = {
    mobile: [
        "(",
        /[1-9]/,
        /\d/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/
    ],
    date: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/],
    ssn: [
        /\d|\*/,
        /\d|\*/,
        /\d|\*/,
        "-",
        /\d|\*/,
        /\d|\*/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/
    ]
};

export default MASK;
